import { render, staticRenderFns } from "./failLogin.vue?vue&type=template&id=c0adb300&"
import script from "./failLogin.vue?vue&type=script&lang=js&"
export * from "./failLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports